import { IconButton } from "shared/components/IconButton";
import { Select, Option } from "shared/components/forms/Select";
import { Trash02 } from "untitledui-js-base";
import { StateOverride } from "views/rent-reporting-settings";
import { STATE_ENROLLMENT_TYPE_OPTIONS } from "../constants";
import { abbrToState } from "shared/app/VerificationTemplate/slices/CountyWalkInTypeSlice/constants";

export const StateOverrideRow = ({
  override,
  index,
  availableStates,
  onUpdate,
  onRemove
}: {
  override: StateOverride;
  index: number;
  availableStates: Option[];
  onUpdate: (index: number, field: keyof StateOverride, value: string) => void;
  onRemove: (index: number) => void;
}) => {
  return (
    <div className="flex items-center gap-x-4 p-4 border border-dashed border-alpha-100 rounded-lg bg-background-900">
      <div className="flex-1">
        <Select
          id={`state-${index}-${override.state}`}
          placeholder="Select state"
          value={override.state || undefined}
          onChange={(e) => onUpdate(index, "state", e.target.value)}
          options={
            override.state
              ? availableStates.concat({
                  label: abbrToState[override.state],
                  value: override.state
                })
              : availableStates
          }
          required
          className="!mb-0"
        />
      </div>
      <div className="flex-1">
        <Select
          id={`enrollment-type-${index}-${override.state}`}
          placeholder="Select enrollment type"
          value={override.enrollmentType || undefined}
          onChange={(e) => onUpdate(index, "enrollmentType", e.target.value)}
          options={STATE_ENROLLMENT_TYPE_OPTIONS}
          required
          className="!mb-0"
        />
      </div>
      <IconButton Icon={Trash02} onClick={() => onRemove(index)} />
    </div>
  );
};
